module.exports = __webpack_public_path__ + "media/images/common/credit_cards/master-d09a824eac170a7380670d3d042ff146.svg";